import { useState, useEffect } from "react";
import styles from "./Banner.module.scss";
import logo from "../../../assets/svg/logo-banner.svg";
import { useUser } from "../../../providers/user.provider";
import { useWindowDimensions } from "../../../services/widthCheck.service";
import CloseIcon from "@mui/icons-material/Close";

interface Style {
  margin?: number;
  plans?: boolean;
  mytol?: boolean;
}

const Banner = (props: Style) => {
  const [close, setClose] = useState<boolean>(true);
  const { width } = useWindowDimensions();

  const { banner, setBanner, payment, user, currentProfile } = useUser();
  const handleClickClose = () => {
    setClose(!close);
    setBanner(false);
  };

  const handleClickClaimOffer = () => {
    return payment.map((item: any) => {
      if (item.description.description === "Premium Year") {
        return window.open(
          item.external_url + `?prefilled_email=${user.email}`,
          "_blank"
        );
      }
    });
  };

  useEffect(() => {
    if (user?.access === "premium" && user?.typeSubscription === "year") {
      setClose(false);
    } else {
      if (!banner) {
        setClose(false);
      }
    }
  }, [close, user]);
  return (
    <>
      {close ? (
        <div className={styles.banner}>
          <div className={styles.banner__inner}>
            {width >= 985 ? (
              <img
                width={114}
                height={45}
                src={logo}
                alt="the only link logo"                
              />
            ) : null}
            <p className={styles.banner__text}>
              <strong>Get 2 Months Free! </strong>Subscribe to the annual plan and enjoy 12 Months for the Price of 10. Get full access, save more, and maximize your Only Link experience!
            </p>
            <button onClick={handleClickClaimOffer}>Claim Offer</button>
          </div>

          <button
            style={{
              background: "transparent",
              border: "none",
              color: "#fff",
              marginLeft: "7px",
              minWidth: "14px",
              height: "24px",
            }}
            onClick={handleClickClose}
          >
            <CloseIcon />
          </button>
        </div>
      ) : null}
    </>
  );
};

export default Banner;
